/* eslint-disable import/first */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

require('dotenv').config()

import Vue from 'vue'
import App from './App'
import router from './router'
import apolloProvider from './apollo'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'

import 'patternfly/dist/css/patternfly.css'
import 'patternfly/dist/css/patternfly-additions.css'
import '../scss/style.scss'

import 'bootstrap/dist/js/bootstrap.js'
import 'patternfly/dist/js/patternfly.js'
import 'patternfly/dist/js/patternfly.dataTables.pfPagination.js'
import 'patternfly/dist/js/patternfly.dataTables.pfEmpty.js'

import 'bootstrap-select/dist/js/bootstrap-select.min.js'

import numFormat from 'vue-filter-number-format'

Vue.filter('numFormat', numFormat)
Vue.use(VueAxios, axios)
Vue.router = router

Vue.config.productionTip = false
Vue.axios.defaults.baseURL = process.env.API_BASE_ENDPOINT
Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token })
    },
    response: function (res) {
      return (res.data || {}).token
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  refreshData: { enabled: false },
  parseUserData: function (data) {
    return data.profile
  },
  loginData: { url: '/login', method: 'POST', redirect: '/projects', fetchUser: true },
  fetchData: { url: '/profile', method: 'GET', enabled: true }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  apolloProvider,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/js/main.js